import { useState } from "react";
import { SignzyService } from "../../application/services/SignzyService";

export const useSignzyConsent = (service: SignzyService) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    const submitConsent = async (consent: string | null) => {
        if (!consent) {
            console.error("Consent value is required");
            setIsError(true);
            return;
        }
        setIsLoading(true);
        try {
            const redirectUrl = await service.submitConsent(consent);
            window.location.replace(redirectUrl);
        } catch (error) {
            console.error("Error submitting consent:", error);
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return { submitConsent, isLoading, isError };
};